import {
    CountryApiData,
    CountryApiResponse,
} from '@/core/domain/countries/models/Country.model';
import { CountryRepository } from '@/core/domain/countries/repositories/country.repository';
import { environment } from '@/env/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CountryImplRepository extends CountryRepository {
    constructor(private readonly http: HttpClient) {
        super();
    }

    override getCountries(language: string): Observable<CountryApiData> {
        const _headers = new HttpHeaders({
            'X-Channel': 'web',
            'X-Api-Key': environment.vivaApi.API_KEY,
        });

        const _params = new HttpParams().set('language', language);

        return this.http
            .get<CountryApiResponse>(
                environment.vivaApi.BASE_HOST +
                    environment.vivaApi.ENDPOINTS.countries,
                { headers: _headers, params: _params },
            )
            .pipe(map((response) => response.data));
    }
}
